import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';

export default function AboutPage() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于8090影视',
    description: '8090影视品牌介绍、口碑评价和联系方式。8090影视打造电影大全平台，聚合最新电影、经典电影、高清电影资源。',
    url: 'https://8090movie.com/about',
    about: {
      '@type': 'Organization',
      name: '8090影视',
      foundingDate: '2018',
      description: '8090影视打造电影大全平台，聚合最新电影、经典电影、高清电影资源，涵盖华语电影、欧美电影等海量片库',
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://8090movie.com/' },
      { '@type': 'ListItem', position: 2, name: '关于我们' },
    ],
  };

  const milestones = [
    { year: '2018', title: '平台创立', description: '8090影视正式成立，致力于打造专业的电影大全平台' },
    { year: '2019', title: '片库破万', description: '电影资源突破10,000部，覆盖华语电影、欧美电影等多个分类' },
    { year: '2020', title: '高清升级', description: '全面升级高清画质播放技术，98%影片支持720P以上清晰度' },
    { year: '2021', title: '用户突破', description: '注册用户突破100万，月活跃用户达500万' },
    { year: '2022', title: '内容拓展', description: '拓展日韩电影、经典电影等专区，片库总量超过20,000部' },
    { year: '2023', title: '体验优化', description: 'UI全新改版，优化推荐算法，提供更精准的电影推荐服务' },
    { year: '2024', title: '持续创新', description: '引入AI智能推荐，为用户打造个性化的电影大全浏览体验' },
  ];

  const reviews = [
    {
      name: '张先生',
      role: '资深影迷',
      content: '8090影视是我每天必刷的电影大全平台，片库非常全，华语电影和欧美电影都能找到，画质也很棒！',
      rating: 5,
    },
    {
      name: '李女士',
      role: '电影爱好者',
      content: '用了两年多了，8090影视的分类做得很好，最新电影更新也快，高清在线观看体验很流畅。',
      rating: 5,
    },
    {
      name: '王同学',
      role: '大学生',
      content: '经典电影资源太全了！在8090影视上看了很多影史经典，对于电影专业的学生来说简直是宝藏平台。',
      rating: 5,
    },
    {
      name: '赵女士',
      role: '白领',
      content: '下班后最喜欢在8090影视上找高分电影看，推荐算法很准，经常能发现好片。',
      rating: 4,
    },
    {
      name: '陈先生',
      role: '影视从业者',
      content: '作为行业内的人，我认可8090影视的专业性。电影大全的分类和检索做得很好，值得推荐。',
      rating: 5,
    },
  ];

  return (
    <>
      <SEOHead
        title="关于我们 - 8090影视 | 电影大全平台品牌介绍"
        description="8090影视品牌介绍：我们打造电影大全平台，聚合最新电影、经典电影、高清电影资源。了解8090影视的品牌故事、口碑评价和联系方式。"
        keywords="8090影视,关于我们,电影大全,品牌介绍,联系方式,口碑评价"
        canonicalUrl="https://8090movie.com/about"
        schema={aboutSchema}
      />
      <ScrollToTop />
      <Navbar />

      <main className="pt-20 pb-16 px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
          />

          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="mt-6 mb-16">
            <div className="text-center mb-12">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
                关于 <span className="text-cinema-gold">8090影视</span>
              </h1>
              <p className="text-cinema-text-dim text-base max-w-2xl mx-auto leading-relaxed">
                8090影视成立于2018年，是一家专注于打造电影大全平台的互联网公司。
                我们致力于聚合最新电影、经典电影、高清电影资源，为用户提供优质的在线观影体验。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
              <div className="bg-cinema-card rounded-lg p-8 border border-cinema-border text-center">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-cinema-gold/10 text-cinema-gold mb-4">
                  <i className="ri-eye-line text-2xl"></i>
                </div>
                <h3 className="text-white font-heading text-lg font-semibold mb-2">品牌愿景</h3>
                <p className="text-cinema-text-dim text-sm leading-relaxed">
                  成为中国最受欢迎的电影大全平台，让每一个热爱电影的人都能在这里找到心仪的影片。
                </p>
              </div>
              <div className="bg-cinema-card rounded-lg p-8 border border-cinema-border text-center">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-cinema-gold/10 text-cinema-gold mb-4">
                  <i className="ri-heart-line text-2xl"></i>
                </div>
                <h3 className="text-white font-heading text-lg font-semibold mb-2">品牌使命</h3>
                <p className="text-cinema-text-dim text-sm leading-relaxed">
                  聚合海量优质电影资源，覆盖华语电影、欧美电影、日韩电影等全品类，用科技让观影更简单。
                </p>
              </div>
              <div className="bg-cinema-card rounded-lg p-8 border border-cinema-border text-center">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-cinema-gold/10 text-cinema-gold mb-4">
                  <i className="ri-shield-star-line text-2xl"></i>
                </div>
                <h3 className="text-white font-heading text-lg font-semibold mb-2">核心价值观</h3>
                <p className="text-cinema-text-dim text-sm leading-relaxed">
                  用户至上、内容为王、技术驱动、诚信经营，用心打造每一部电影的观影体验。
                </p>
              </div>
            </div>

            <div className="mb-16">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-white text-center mb-10">
                品牌 <span className="text-cinema-gold">历程</span>
              </h2>
              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-cinema-border" />
                <div className="space-y-8">
                  {milestones.map((item, index) => (
                    <div
                      key={index}
                      className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                        index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                      }`}
                    >
                      <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'} pl-10 md:pl-0`}>
                        <div className={`${index % 2 === 0 ? 'md:pr-12' : 'md:pl-12'}`}>
                          <span className="inline-block px-3 py-1 text-xs font-semibold bg-cinema-gold/10 text-cinema-gold rounded-full mb-2">
                            {item.year}
                          </span>
                          <h3 className="text-white font-heading text-lg font-semibold mb-1">{item.title}</h3>
                          <p className="text-cinema-text-dim text-sm">{item.description}</p>
                        </div>
                      </div>
                      <div className="absolute left-3 md:left-1/2 top-1.5 w-3 h-3 rounded-full bg-cinema-gold border-2 border-cinema-dark -translate-x-1/2 z-10" />
                      <div className="flex-1 hidden md:block" />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="mb-16">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-white text-center mb-10">
                用户 <span className="text-cinema-gold">口碑</span>
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {reviews.map((review, index) => (
                  <div key={index} className="bg-cinema-card rounded-lg p-6 border border-cinema-border">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-xs ${i < review.rating ? 'ri-star-fill text-cinema-gold' : 'ri-star-line text-cinema-text-dim'}`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-cinema-text-dim text-sm leading-relaxed mb-4">
                      "{review.content}"
                    </p>
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full bg-cinema-gold/10 flex items-center justify-center text-cinema-gold text-xs font-bold">
                        {review.name[0]}
                      </div>
                      <div>
                        <div className="text-white text-sm font-medium">{review.name}</div>
                        <div className="text-cinema-text-dim text-xs">{review.role}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-white text-center mb-10">
                联系 <span className="text-cinema-gold">我们</span>
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="bg-cinema-card rounded-lg p-8 border border-cinema-border">
                  <h3 className="text-white font-heading text-lg font-semibold mb-6">联系方式</h3>
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-cinema-gold/10 text-cinema-gold flex-shrink-0">
                        <i className="ri-mail-line"></i>
                      </div>
                      <div>
                        <div className="text-white text-sm font-medium">电子邮箱</div>
                        <div className="text-cinema-text-dim text-sm">contact@8090movie.com</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-cinema-gold/10 text-cinema-gold flex-shrink-0">
                        <i className="ri-phone-line"></i>
                      </div>
                      <div>
                        <div className="text-white text-sm font-medium">客服电话</div>
                        <div className="text-cinema-text-dim text-sm">400-800-8090</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-cinema-gold/10 text-cinema-gold flex-shrink-0">
                        <i className="ri-map-pin-line"></i>
                      </div>
                      <div>
                        <div className="text-white text-sm font-medium">公司地址</div>
                        <div className="text-cinema-text-dim text-sm">北京市朝阳区影视产业园A座8090室</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-cinema-gold/10 text-cinema-gold flex-shrink-0">
                        <i className="ri-time-line"></i>
                      </div>
                      <div>
                        <div className="text-white text-sm font-medium">工作时间</div>
                        <div className="text-cinema-text-dim text-sm">周一至周五 9:00 - 18:00</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-cinema-card rounded-lg p-8 border border-cinema-border">
                  <h3 className="text-white font-heading text-lg font-semibold mb-6">给我们留言</h3>
                  <form
                    className="space-y-4"
                    data-readdy-form
                    action="https://readdy.ai/api/form/d9oc62cit35ii3jdm5mg"
                    method="POST"
                  >
                    <div>
                      <input
                        type="text"
                        name="name"
                        placeholder="您的姓名"
                        required
                        className="w-full px-4 py-3 text-sm bg-cinema-black border border-cinema-border rounded-lg text-cinema-text placeholder-cinema-text-dim focus:outline-none focus:border-cinema-gold transition-colors"
                      />
                    </div>
                    <div>
                      <input
                        type="email"
                        name="email"
                        placeholder="您的邮箱"
                        required
                        className="w-full px-4 py-3 text-sm bg-cinema-black border border-cinema-border rounded-lg text-cinema-text placeholder-cinema-text-dim focus:outline-none focus:border-cinema-gold transition-colors"
                      />
                    </div>
                    <div>
                      <textarea
                        name="message"
                        placeholder="请输入您的留言..."
                        rows={4}
                        maxLength={500}
                        required
                        className="w-full px-4 py-3 text-sm bg-cinema-black border border-cinema-border rounded-lg text-cinema-text placeholder-cinema-text-dim focus:outline-none focus:border-cinema-gold transition-colors resize-none"
                      ></textarea>
                      <div className="text-cinema-text-dim text-xs mt-1 text-right">最多500字</div>
                    </div>
                    <div className="form-spam-guard">
                      <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                    </div>
                    <button
                      type="submit"
                      className="w-full px-6 py-3 bg-cinema-gold text-cinema-black font-semibold rounded-lg hover:bg-cinema-gold-light transition-colors text-sm whitespace-nowrap cursor-pointer"
                    >
                      发送留言
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}